import { z } from 'zod';

const currentYear = new Date().getFullYear();

export const employeeNotaFiscalInputSchema = z.object({
  clienteCodigo: z
    .number({ invalid_type_error: 'Cliente obrigatório' })
    .int()
    .positive('Cliente obrigatório'),
  mes: z
    .number({ invalid_type_error: 'Mês obrigatório' })
    .int()
    .min(1, 'Mês entre 1 e 12')
    .max(12, 'Mês entre 1 e 12'),
  ano: z
    .number({ invalid_type_error: 'Ano obrigatório' })
    .int()
    .min(2000, 'Ano inválido')
    .max(currentYear + 1, 'Ano inválido'),
});

export type EmployeeNotaFiscalFormValues = z.infer<typeof employeeNotaFiscalInputSchema>;
